export default __webpack_public_path__ + "static/media/UniversLTStd-LightObl.f816ca2a.otf";